import React from 'react'

// The post as it will look on Instagram: in the feed with the profile row,
// buttons and caption, or as a Story with the bars and reply box on top
// (which is why a Story's words sit in the middle band).
export const FEED_CHROME = { top: 52, bottom: 96 }

const handleOf = (name) => String(name || 'yoursalon').toLowerCase().replace(/[^a-z0-9._]/g, '').slice(0, 24) || 'yoursalon'
const Avatar = ({ name, logo }) => (
  <span className="sx-ig-avatar" aria-hidden>
    <span>{logo ? <img src={logo} alt="" /> : String(name || 'B').trim().charAt(0).toUpperCase()}</span>
  </span>
)
const Icon = ({ d }) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>{d}</svg>
const HEART = <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8Z" />
const COMMENT = <path d="M21 11.5a8.4 8.4 0 0 1-12.4 7.4L3 21l2-5.1A8.5 8.5 0 1 1 21 11.5Z" />
const SEND = <path d="m22 2-7 20-4-9-9-4 20-7Z" />
const SAVE = <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z" />

const InstagramFrame = ({ format, width, name, logo, caption, children }) => {
  const handle = handleOf(name)
  if (format === 'story') {
    return (
      <div className="sx-ig sx-ig--story" style={{ width }}>
        {children}
        <div className="sx-ig-story-top" aria-hidden>
          <span className="sx-ig-bars"><i className="is-on" /><i /></span>
          <span className="sx-ig-story-who"><Avatar name={name} logo={logo} /><b>{handle}</b><span>2h</span></span>
        </div>
        <div className="sx-ig-story-bottom" aria-hidden>
          <span className="sx-ig-reply">Send message</span>
          <Icon d={HEART} />
          <Icon d={SEND} />
        </div>
      </div>
    )
  }
  const first = String((caption && caption.text) || '').split('\n')[0]
  return (
    <div className="sx-ig sx-ig--feed" style={{ width }}>
      <div className="sx-ig-head" style={{ height: FEED_CHROME.top }} aria-hidden>
        <Avatar name={name} logo={logo} />
        <b>{handle}</b>
        <span className="sx-ig-dots">•••</span>
      </div>
      {children}
      <div className="sx-ig-foot" style={{ minHeight: FEED_CHROME.bottom }} aria-hidden>
        <div className="sx-ig-actions"><Icon d={HEART} /><Icon d={COMMENT} /><Icon d={SEND} /><span className="sx-ig-save"><Icon d={SAVE} /></span></div>
        <p className="sx-ig-caption"><b>{handle}</b> {first}{first.length > 60 || String((caption && caption.text) || '').includes('\n') ? <span className="sx-ig-more"> more</span> : null}</p>
      </div>
    </div>
  )
}

export default InstagramFrame
